import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useBiddingPrograms = () => {
  return useQuery({
    queryKey: ["bidding_programs"],
    queryFn: async () => await apiClient.getBiddingPrograms(),
  });
};
